"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TRACKING_STATUS = exports.EShippingTypes = exports.Shipment = void 0;
const Common_1 = require("./Common");
const Address_1 = require("./Address");
const Base_1 = require("./Base");
const index_1 = require("../index");
const bluebird_1 = require("bluebird");
class Shipment extends Base_1.Base {
    type = EShippingTypes.None;
    from_address = null;
    to_address = null;
    from_address_default = null;
    distance = null;
    requested = null;
    scheduled = null;
    canceled = null;
    sent = null;
    delivered = null;
    total_height = null; // deprecate eventually.
    total_length = null; // deprecate eventually.
    total_width = null; // deprecate eventually.
    total_weight = null;
    total_weight_ounces = null;
    nmfc_class = null; // deprecate eventually. set in packaging
    amount = null;
    cost = null;
    notes = '';
    ltl = null;
    liftgate = null;
    free = false;
    rates = [];
    rate = null;
    rate_status = ''; // deprecate eventually.
    postage_label = null;
    is_return = null;
    tracking_code = '';
    tracking_url = '';
    pickup_code = '';
    status = TRACKING_STATUS.NONE;
    tracker = null;
    packaging = null; // deprecate eventually.
    packing_list = ''; // deprecate?
    third_party = [];
    metadata = {};
    items = new index_1.ChildArray(); // deprecate eventually
    events = new index_1.ChildArray();
    files = new index_1.ChildArray();
    pallets = []; // deprecate eventually.
    packages = null;
    _s = ['from_address', 'to_address', 'packages', 'requested', 'status', 'tracking_code', 'rate.carrier', 'rate.list_rate'];
    get from_address_id() {
        return this.from_address?.id || '';
    }
    get to_address_id() {
        return this.to_address?.id || '';
    }
    get name() {
        if (this.rate?.carrier) {
            return `${this.rate.carrier} ${this.rate.service}`;
        }
        else {
            return `Incomplete Shipment`;
        }
    }
    _warnings = [];
    get errors() {
        return (this.metadata?.messages || []).reduce((w, m) => {
            if (m.type !== 'warning') {
                w.push(m);
            }
            return w;
        }, []);
    }
    get warnings() {
        return (this.metadata?.messages || []).reduce((w, m) => {
            if (m.type === 'warning') {
                w.push(m);
            }
            return w;
        }, []);
    }
    constructor(data, olMap) {
        super('shipments', 24);
        (0, Common_1.setObjectProperties)(this, data, olMap, Shipment);
        // For backward-compat with old NXT
        if (!this.packages) {
            this.packages = this.pallets || [];
        }
        if (this.liftgate === null && this.metadata?.liftgate) {
            this.liftgate = this.metadata.liftgate;
        }
    }
    shouldBeLTL() {
        if (this.total_weight && this.total_weight > 150) {
            return true;
        }
        else if (this.total_width && this.total_width > 100) {
            return true;
        }
        else if (this.total_length && this.total_length > 100) {
            return true;
        }
        return false;
    }
    toString() {
        return `Shipment: ${this.rate?.carrier} ${this.rate?.service}`;
    }
    setDimensions(opts) {
        [
            { dim: 'Height', prop: 'total_height' },
            { dim: 'Width', prop: 'total_width' },
            { dim: 'Length', prop: 'total_length' }
        ].forEach(i => {
            let total = this.getLargestDimension(i.dim);
            if (this.metadata.sumDim && this.metadata.sumDim === i.dim) {
                total = this.sumDimension(i.dim);
            }
            this[i.prop] = total || this[i.prop];
        });
        if (this.packaging?.manual && this.packaging?.weight) {
            this.total_weight = this.packaging.weight;
        }
        else if (this.packages?.length) {
            this.total_weight = (0, Common_1.round)(this.packages.reduce((n, p, i) => {
                if (opts) {
                    // @ts-ignore
                    this.packages[i] = (0, index_1.loadObject)(this.items[i], opts);
                }
                this.packages[i].setDimensions();
                // @ts-ignore
                n += (this.packages[i].weight || 0);
                return n;
            }, 0), 2);
        }
        else if (this.items?.length) {
            this.total_weight = (0, Common_1.round)(this.items.reduce((n, item, i) => {
                if (opts) {
                    // @ts-ignore
                    this.items[i] = (0, index_1.loadObject)(this.items[i], opts);
                }
                // @ts-ignore
                if (this.items[i]._override_weight) {
                    // @ts-ignore
                    n += (this.items[i]._override_weight || 0);
                }
                else {
                    // @ts-ignore
                    if (this.items[i].calc) {
                        // @ts-ignore
                        this.items[i].calc(this);
                    }
                    // @ts-ignore
                    n += (this.items[i].total_weight || 0);
                }
                return n;
            }, 0), 2);
        }
        // Default small packages to 8oz?
        this.total_weight_ounces = this.total_weight ? (0, Common_1.round)((this.total_weight * 16), 0) : 8;
    }
    getLargestDimension(dim) {
        let result;
        if (this.packaging?.manual && this.packaging.dimensions?.get && this.packaging.dimensions?.get(dim)?.size) {
            result = this.packaging.dimensions?.get(dim)?.size;
        }
        else {
            this.items?.forEach(i => {
                if (i.dimensions?.get && i.dimensions?.get(dim)?.size && (!result || i.dimensions?.get(dim)?.size > result)) {
                    result = i.dimensions.get(dim).size;
                }
            });
        }
        // @ts-ignore
        return result;
    }
    sumDimension(dim) {
        let result = 0;
        if (this.packaging?.manual && this.packaging.dimensions?.get && this.packaging.dimensions?.get(dim)?.size) {
            result = this.packaging.dimensions?.get(dim)?.size;
        }
        else {
            this.items?.forEach(i => {
                if (i.dimensions?.get && i.dimensions?.get(dim)?.size) {
                    result += (i.dimensions.get(dim).size * i.quantity);
                }
            });
        }
        // @ts-ignore
        return result;
    }
    addMessage(msg) {
        this.metadata = this.metadata || {};
        this.metadata.messages = this.metadata.messages || [];
        if (!this.metadata.messages.find((i) => i.provider === msg.provider && i.message === msg.message)) {
            this.metadata.messages.push(msg);
            console.log('addMessage', msg);
        }
    }
    removeMessage(msg) {
        this.metadata = this.metadata || {};
        this.metadata.messages = this.metadata.messages || [];
        let i = this.metadata.messages.findIndex((i) => i.provider === msg.provider && i.message === msg.message);
        if (i > -1) {
            this.metadata.messages.splice(i, 1);
        }
    }
    toJSON() {
        this.setDimensions(null);
        let r = super.toJSON();
        if (this.items) {
            delete r.items;
        }
        if (this.pallets?.length) {
            r.pallets = this.pallets.map(p => p.toFullJSON());
        }
        if (this.packages?.length) {
            r.packages = this.packages.map(p => p.toFullJSON());
        }
        return r;
    }
    toMinJSON(ignoreDocRef) {
        let r = super.toMinJSON(ignoreDocRef);
        this.setDimensions();
        ['id', 'retail_rate', 'rate', 'total_height', 'total_length', 'total_width', 'total_weight', 'total_weight_ounces', 'status']
            .forEach(p => {
            // @ts-ignore
            if (this[p]) {
                // @ts-ignore
                r[p] = this[p];
            }
        });
        return r;
    }
    async save(parent, fSvc) {
        this.setDimensions();
        if (this.to_address?.id && !this.to_address._docRef && parent.contact?._docRef) {
            let to = new Address_1.Address(this.to_address);
            await to.save(parent.contact, fSvc);
            this.to_address = to;
        }
        await super.save(parent, fSvc);
        if (this.items?.length) {
            await bluebird_1.Promise.map(this.items, async (item) => {
                await item.save(this, fSvc);
            }, { concurrency: 50 });
        }
        // TODO, are we going to have to make 'packages' a child array due to object size issues?
        // if (this.packages?.length) {
        //     await Promise.map(this.packages, async (item: any) => {
        //         await item.save(this, fSvc);
        //     }, { concurrency: 50 });
        // }
    }
    async checkValidity(order) {
        this._warnings = [];
        // check items locations to make sure they are compatible
        let nmfc_classes = [];
        let locations = [];
        // @ts-ignore
        await Promise.all(this.items?.map(async (item, n) => {
            if (item.sku && this._docRef) {
                let q = await this._docRef.parent.parent.parent.parent.collection('products').where('sku', '==', item.sku).get();
                if (q.size) {
                    let p = new index_1.Product(q.docs[0]);
                    if (p.address?.id && !locations.find(a => a.id === p.address?.id)) {
                        locations.push(p.address);
                    }
                    if (p.nmfc_class && !nmfc_classes.includes(p.nmfc_class)) {
                        nmfc_classes.push(p.nmfc_class);
                    }
                    if (p.weight !== item.unit_weight) {
                        item.unit_weight = p.weight;
                    }
                }
            }
        }));
        if (locations.length > 1) {
            this._warnings.push('Incompatible Items! Items sourced from different locations cannot be in the same order.');
        }
        else if (locations.length) {
            // If the default location changed, the user probably changed items in the shipment.
            // Force them to re-select the FROM just to make sure they get it right.
            if (this.from_address_default?.id && this.from_address_default?.id !== locations[0].id) {
                delete this.from_address;
            }
            else if (!this.from_address?.id) {
                this.from_address = locations[0];
            }
            this.from_address_default = locations[0];
        }
        if (nmfc_classes.length === 1 && this.nmfc_class !== nmfc_classes[0]) {
            this.nmfc_class = nmfc_classes[0];
        }
        if (order) {
            if (!this.items?.length) {
                this._warnings.push('Shipment has no items. Check the Items tab.');
            }
            if (!this.to_address?.id) {
                this._warnings.push('TO address not selected. Check the To tab.');
            }
            if (!this.from_address?.id) {
                this._warnings.push('FROM address not selected. Check the From tab.');
            }
            if (order._type !== 'quotes') {
                if (!this.rate?.carrier) {
                    this._warnings.push('No shipper/carrier selected. Check the Rates tab, or click Get Rates.');
                }
            }
            if (order?.invoice_id && order?.metadata?.shipping_total && order?.metadata?.shipping_total !== this.amount && !this.free) {
                this._warnings.push('The shipping amount on the original order does not match the total on this shipment. Check the Rates tab on the shipment.');
            }
        }
    }
    pickRate(order) {
        if (this.rates?.length) {
            for (let rate of this.rates) {
                if (order?.selected_rate
                    && order?.selected_rate?.carrier === rate.carrier
                    && order?.selected_rate?.service === rate.service) {
                    // console.log('selectRate 1', rate);
                    this.rate = rate;
                    break;
                }
                else if (rate.default) {
                    // console.log('selectRate 2', rate);
                    this.rate = rate;
                    break;
                }
                else if (!this.rate?.carrier ||
                    Number(rate?.retail_rate || rate?.list_rate) < Number(this.rate?.retail_rate || this.rate?.list_rate)) {
                    // console.log('selectRate 3', rate);
                    this.rate = rate;
                }
            }
        }
        // TODO Use get/set third party id for UPS account
        if (this.getThirdPartyId('ups')) {
            this.cost = 0;
            this.amount = 0;
        }
        else if (this.rate?.carrier) {
            this.cost = Number(this.rate.list_rate);
            this.amount = this.free ? 0 : Number(this.rate.retail_rate || this.rate.list_rate);
            this.type = this.rate.type;
        }
        if (order) {
            order.shipping = (this.free) ? 0 : this.amount;
            order.selected_rate = this.rate;
            order.calc();
            // console.log('PICK RATE!', order.shipping);
        }
    }
}
exports.Shipment = Shipment;
var EShippingTypes;
(function (EShippingTypes) {
    EShippingTypes["UPS"] = "UPS";
    EShippingTypes["EasyPost"] = "EasyPost";
    EShippingTypes["EP"] = "EP";
    EShippingTypes["Averitt"] = "Averitt";
    EShippingTypes["Alside"] = "Alside";
    EShippingTypes["XPO"] = "XPO";
    EShippingTypes["RoadRunner"] = "RoadRunner";
    EShippingTypes["TMS"] = "TMS";
    EShippingTypes["R_AND_L"] = "R&L";
    EShippingTypes["EveryWindow"] = "EW";
    EShippingTypes["Custom"] = "Custom";
    EShippingTypes["Other"] = "O";
    EShippingTypes["TForce"] = "TForce";
    EShippingTypes["None"] = "";
})(EShippingTypes || (exports.EShippingTypes = EShippingTypes = {}));
var TRACKING_STATUS;
(function (TRACKING_STATUS) {
    TRACKING_STATUS["NONE"] = "";
    TRACKING_STATUS["PRE_TRANSIT"] = "pre_transit";
    TRACKING_STATUS["OUT_FOR_DELIVERY"] = "out_for_delivery";
    TRACKING_STATUS["IN_TRANSIT"] = "in_transit";
    TRACKING_STATUS["DELIVERED"] = "delivered";
    TRACKING_STATUS["PROBLEM"] = "problem";
})(TRACKING_STATUS || (exports.TRACKING_STATUS = TRACKING_STATUS = {}));
index_1.olm.shipments = (ref, map) => {
    return new Shipment(ref, map);
};
